module.exports = __webpack_public_path__ + "img/logo_bg.9611fd0a.png";